(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-accessories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabsRoots = document.querySelectorAll('.featured-accessories__tabs');
    tabsRoots.forEach(function (tabsEl) {
      var section = tabsEl.closest('[id^="shopify-section-"]');
      if (!section) return;
      var tabs = section.querySelectorAll('.featured-accessories__tab');
      var panels = section.querySelectorAll('.featured-accessories__panel');
      function activate(target) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === target;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === target;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () { activate(tab.getAttribute('data-tab')); });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = (idx + dir + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next].getAttribute('data-tab'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-headwear"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabsRoots = document.querySelectorAll('.featured-headwear__tabs');
    tabsRoots.forEach(function (tabsEl) {
      var section = tabsEl.closest('[id^="shopify-section-"]');
      if (!section) return;
      var tabs = section.querySelectorAll('.featured-headwear__tab');
      var panels = section.querySelectorAll('.featured-headwear__panel');
      function activate(target) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === target;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === target;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () { activate(tab.getAttribute('data-tab')); });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = (idx + dir + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next].getAttribute('data-tab'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mens-essentials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tabsRoots = document.querySelectorAll('.mens-essentials__tabs');
    tabsRoots.forEach(function (tabsEl) {
      var section = tabsEl.closest('[id^="shopify-section-"]');
      if (!section) return;
      var tabs = section.querySelectorAll('.mens-essentials__tab');
      var panels = section.querySelectorAll('.mens-essentials__panel');
      function activate(target) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === target;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-panel') === target;
          p.classList.toggle('is-active', on);
          if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
        });
      }
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function () { activate(tab.getAttribute('data-tab')); });
        tab.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var dir = e.key === 'ArrowRight' ? 1 : -1;
          var next = (idx + dir + tabs.length) % tabs.length;
          tabs[next].focus();
          activate(tabs[next].getAttribute('data-tab'));
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('[data-section-type="shop-by-category-tabs"]');
  if (!sections.length) return;

  sections.forEach(initSection);

  function initSection(section) {
    const tabButtons = section.querySelectorAll('[data-tab-button]');
    const panels = section.querySelectorAll('[data-tab-panel]');
    const shopAllLinks = section.querySelectorAll('[data-shop-all]');

    if (!tabButtons.length || !panels.length) return;

    function activateTab(index, focusButton) {
      tabButtons.forEach((btn) => {
        const isActive = Number(btn.dataset.tabIndex) === index;
        btn.classList.toggle('sbc__tab--active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && focusButton) btn.focus();
      });
      panels.forEach((panel) => {
        const isActive = Number(panel.dataset.tabIndex) === index;
        if (isActive) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        if (isActive) updateNav(panel);
      });
      shopAllLinks.forEach((link) => {
        const isActive = Number(link.dataset.tabIndex) === index;
        link.classList.toggle('sbc__shop-all--active', isActive);
        link.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        link.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    function updateNav(panel) {
      const track = panel.querySelector('[data-track]');
      const prev = panel.querySelector('[data-scroll-prev]');
      const next = panel.querySelector('[data-scroll-next]');
      if (!track || !prev || !next) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 8;
      const atEnd = track.scrollLeft >= maxScroll - 8;
      const overflow = maxScroll > 8;
      prev.hidden = !overflow || atStart;
      next.hidden = !overflow || atEnd;
      prev.tabIndex = prev.hidden ? -1 : 0;
      next.tabIndex = next.hidden ? -1 : 0;
    }

    tabButtons.forEach((btn) => {
      btn.addEventListener('click', () => activateTab(Number(btn.dataset.tabIndex), false));
    });

    section.addEventListener('keydown', (e) => {
      if (!e.target.matches('[data-tab-button]')) return;
      const total = tabButtons.length;
      let next = null;
      if (e.key === 'ArrowRight') next = (Number(e.target.dataset.tabIndex) + 1) % total;
      else if (e.key === 'ArrowLeft') next = (Number(e.target.dataset.tabIndex) - 1 + total) % total;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = total - 1;
      if (next !== null) {
        e.preventDefault();
        activateTab(next, true);
      }
    });

    panels.forEach((panel) => {
      const track = panel.querySelector('[data-track]');
      const prev = panel.querySelector('[data-scroll-prev]');
      const next = panel.querySelector('[data-scroll-next]');
      if (!track || !prev || !next) return;

      let raf = null;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          updateNav(panel);
          raf = null;
        });
      });

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      next.addEventListener('click', () => {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });

      window.addEventListener('resize', () => updateNav(panel));
      requestAnimationFrame(() => updateNav(panel));
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
